import React, { useState } from "react"
import HTMLEllipsis from "react-lines-ellipsis/lib/html"
import { ReactComponent as Close } from "./images/close.svg"
import { ReactComponent as Jfilm } from "./images/logo_jfilm.svg"
import { ReactComponent as Shorts } from "./images/logo_pittsburgh_shorts.svg"
import reelabilities from "./images/logo_reelabilities.png"

const EventDetails = (props) => {
  const { event, festival, handleClose, path, screenings, ticketing } = props

  const getBlockBuyLink = (event) => {
    let foundTicket = ticketing.find((ticket) => {
      if (ticket.film === event.title) {
        return ticket
      }
    })

    if (foundTicket) {
      return foundTicket.url
    } else {
      foundTicket = ticketing
        .filter(
          (ticket) =>
            ticket.film !== "*Passes" && ticket.film !== "*All Festival Pass",
        )
        .find((ticket) => {
          if (event.title.match(new RegExp(ticket.film, "gi"))) {
            return ticket
          } else if (
            ticket.film
              .replace("–", "-")
              .replace(/\(+|\)+/gm, "")
              .match(
                new RegExp(
                  event.title
                    .replace("–", "-")
                    .replace(/\(+|\)+/gm, "")
                    .replace(" - RAD Days", ""),
                  "gi",
                ),
              )
          ) {
            return ticket
            // try matching after removing extra info before or after hyphens
          } else if (
            ticket.film
              .replace(/^(\d+ - )/gm, "")
              .replace(/( - .+)$/gm, "")
              .match(
                new RegExp(
                  event.title
                    .replace(/^(\d+ - )/gm, "")
                    .replace(/( - .+)$/gm, "")
                    .replace(" - RAD Days", ""),
                ),
              )
          ) {
            return ticket
          } else if (
            ticket.film
              .replace(/^(\d+\w+ - )/gm, "")
              .replace(/( - .+)$/gm, "")
              .match(
                new RegExp(
                  event.title
                    .replace(/^(\d+\w+ - )/gm, "")
                    .replace(/( - .+)$/gm, "")
                    .replace(" - RAD Days", ""),
                ),
              )
          ) {
            return ticket
          } else if (
            ticket.film.match(
              new RegExp(
                event.title
                  .replace("–", "-")
                  .replace(" - Virtual", " VIRTUAL")
                  .replace("’", "'")
                  .replace(" - RAD Days", ""),
                "gi",
              ),
            )
          ) {
            return ticket
          } else if (
            ticket.film.match(
              event.title.replace("–", "-").replace(" - Virtual", ""),
            )
          ) {
            return ticket
          }
        })

      if (foundTicket) {
        return foundTicket.url
      } else {
        return event.tickets
      }
    }
  }

  // const getScreeningLink = (id) => {
  //   const foundScreening = screenings.find((screen) => {
  //     if (screen.films.find((film) => film.id === id)) {
  //       return true
  //     }
  //   })

  //   if (foundScreening) {
  //     return `https://watch.eventive.org/${path}/play/${foundScreening.id}`
  //   }
  // }

  return (
    <div className="film-modal-wrapper">
      <div className="film-modal">
        {event.featured && (
          <div className="film-modal__image">
            <img
              src={event.featured}
              alt={event.featured_alt}
              className={event.featured_focus ? event.featured_focus.css : ""}
            />
          </div>
        )}

        <div className="film-modal__details">
          <h3>{event.title}</h3>

          {event.subtitle && (
            <h4 className="event-subtitle">{event.subtitle}</h4>
          )}

          {event.venue && !event.venue.match(/Virtual/gi) && (
            <>
              <h4 className="modal-heading">Venue</h4>
              <p>{event.venue}</p>
            </>
          )}

          <h4 className="modal-heading">Details</h4>
          {((event.genres || []).length > 0 ||
            (event.genres || []).length > 0 ||
            (event.languages || []).length > 0 ||
            event.runtime) && (
            <p>
              {(event.genres || []).length > 0 && `${event.genres.join(" / ")}`}

              {(event.genres || []).length > 0 &&
                (event.languages || []).length > 0 &&
                " / "}

              {(event.languages || []).length > 0 &&
                `${event.languages.join(" / ")}`}

              {event.runtime &&
                ((event.genres || []).length > 0 ||
                  (event.languages || []).length > 0) &&
                " / "}

              {event.runtime &&
                `${event.runtime}${
                  event.runtime.match(/minutes/)
                    ? ""
                    : event.runtime.match(/minute/)
                    ? ""
                    : parseInt(event.runtime.replace(/\D/, "")) === 1
                    ? "minute"
                    : " minutes"
                }`}
            </p>
          )}

          {event.films.length > 1 ? (
            <>
              {event.url && <a href={event.url}>Learn More</a>}
              <div className="film-block">
                {event.films
                  .sort((a, b) => {
                    if (
                      a.name.replace(/\W|\d/g, "") ===
                      b.name.replace(/\W|\d/g, "")
                    ) {
                      return (
                        parseInt(a.name.replace(/\D/g, "")) -
                        parseInt(b.name.replace(/\D/g, ""))
                      )
                    }
                    return a.name > b.name ? 1 : -1
                  })
                  .map((film, index) => (
                    <React.Fragment key={index}>
                      {film.document && (
                        <a
                          className="film-card"
                          href={`/films/${film.document.slug}`}
                        >
                          {film.still_image && (
                            <div className="film-card__image">
                              <img src={film.still_image} />
                              {film.exclusive && (
                                <div className="exclusive">
                                  <h4>Exclusive</h4>
                                </div>
                              )}
                            </div>
                          )}
                          <div className="film-card__details">
                            <h3>{film.name}</h3>
                            <p>
                              {(film.document.genres || []).length > 0 &&
                                `${film.document.genres.join(" / ")} / `}
                              {(film.document.languages || []).length > 0 &&
                                `${film.document.languages.join(" / ")} / `}
                              {film.details.runtime &&
                                `${film.details.runtime}${
                                  film.details.runtime.match(/minutes/)
                                    ? ""
                                    : film.details.runtime.match(/minute/)
                                    ? ""
                                    : parseInt(
                                        film.details.runtime.replace(/\D/, ""),
                                      ) === 1
                                    ? "minute"
                                    : " minutes"
                                }`}
                            </p>
                          </div>
                        </a>
                      )}
                    </React.Fragment>
                  ))}
              </div>
            </>
          ) : (
            <>
              <div className="film-modal__description no-margin">
                <HTMLEllipsis maxLine={6} unsafeHTML={event.description} />
              </div>
              {event.url && <a href={event.url}>Learn More</a>}
            </>
          )}

          <div className="film-modal__buttons">
            {getBlockBuyLink(event) && (
              <a
                href={getBlockBuyLink(event)}
                target="_blank"
                rel="noopener noreferrer"
                className="button"
              >
                Buy
              </a>
            )}

            {/* {event.eventive_id && (
              <a
                href={getScreeningLink(event.eventive_id)}
                target='_blank'
                rel='noopener noreferrer'
              >
                I already have a pass
              </a>
            )} */}
          </div>
        </div>

        <button
          className="film-modal__close"
          aria-label="close details"
          onClick={handleClose}
        >
          <Close />
        </button>
      </div>
    </div>
  )
}

export default EventDetails
